import type { FC } from 'react';

import { PASSWORD_MIN_LENGTH } from 'schemas/passwordRules';

import classes from '../modules/Registration/register.module.scss';

export const PasswordRulesHint: FC = () => (
  <p className={classes.passwordRulesHint}>
    Не меньше {PASSWORD_MIN_LENGTH} символов, заглавная, строчная и цифра.
  </p>
);
